// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {AudioDeviceMode, AudioInputChannel, AudioInputChannelGroupResponse, AudioInputChannelResponse, AudioOutputChannel} from "@models";

import {SimConfigurationService, SimEnumExtendedService} from "@services";
import {Translations} from "@translations";
import {MatChipSelectionChange} from "@angular/material/chips";

@Component({
	selector: "sim-audio-input-device",
	templateUrl: "./audio-input-device.component.html",
	styleUrls: ["./audio-input-device.component.scss"],
	standalone: false,
})
export class AudioInputDeviceComponent implements OnInit {
	@Input() inputChannel: AudioInputChannel | AudioInputChannelResponse | AudioInputChannelGroupResponse;
	@Input() isMaster: boolean;
	//GUI Setting - more padding for v15 Angular material slider
	@Input() additionalPadding: boolean = false;
	@Input() volume: number;
	@Input() ampVolume: number;
	@Input() showSolo = true;
	@Input() showRec = true;
	@Input() showLife = true;
	@Input() showMute = true;

	@Input() solo: boolean;
	@Input() mutedRec: boolean;
	@Input() mutedBroadcast: boolean;
	@Input() muted: boolean;

	@Input() selectedAudioOutputChannelIds: string[];
	@Input() currentAudioOutputChannels: AudioOutputChannel[];

	@Input() isRecDisabled: boolean;
	@Input() isBroadcastDisabled: boolean;
	@Input() isMuteDisabled: boolean;

	volumeChanged = output<number>();
	soloButtonClicked = output<void>();
	recButtonClicked = output<void>();
	broadcastButtonClicked = output<void>();
	muteButtonClicked = output<void>();

	toggleAudioChannel = output<{
		audioInputChannelId: string;
		audioOutputChannelId: string;
	}>();

	settings = SimConfigurationService.settings;
	AudioDeviceMode = AudioDeviceMode;

	T = Translations;

	constructor(private _simEnumExtendedService: SimEnumExtendedService) {}

	public ngOnInit(): void {}

	public getFontIcon() {
		const inputChannel = this.inputChannel as AudioInputChannelResponse | AudioInputChannel;

		if (!this.isMaster && inputChannel.icon !== undefined) {
			return this._simEnumExtendedService.getFontIcon(inputChannel.icon);
		}

		return "fa-speaker";
	}

	handleAudioChannelSelection(audioInputChannelId: string, audioOutputChannelId: string, $event: MatChipSelectionChange) {
		if ($event.isUserInput) {
			this.toggleAudioChannel.emit({
				audioInputChannelId,
				audioOutputChannelId,
			});
		}
	}
}
